import React, { useEffect, useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { trackInvitationOpen } from '../api/adpilotApi';

function LoginPage({ onLoginSuccess, loginError }) {
  const [invitationCode, setInvitationCode] = useState(
    () => new URLSearchParams(window.location.search).get('invite') || '',
  );

  useEffect(() => {
    if (invitationCode) trackInvitationOpen(invitationCode).catch(() => {});
    // Opening is tracked once; edits to the field are not link opens.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSuccess = (credentialResponse) => {
    // Send the RAW Google credential. The backend verifies the ID token
    // server-side — the client never decides who it is.
    if (credentialResponse?.credential) {
      onLoginSuccess(credentialResponse.credential, invitationCode.trim());
    }
  };

  return (
    <div className="login-page">
      <section className="login-story">
        <div className="login-brand"><span className="brand-mark">A</span> AdPilot</div>
        <div className="login-copy">
          <p className="eyebrow">Your marketing operator</p>
          <h1>Less dashboard.<br />More momentum.</h1>
          <p>
            AdPilot watches every campaign, finds the next move, and brings you
            one clear brief. You stay in control of every change.
          </p>
        </div>
        <div className="login-proof">
          <span>Human-approved changes</span>
          <span>Clear audit trail</span>
        </div>
      </section>
      <section className="login-action">
        <div className="login-card">
          <h2>Welcome to AdPilot</h2>
          <p>Sign in to open your daily marketing brief.</p>
          {loginError && (
            <p className="login-error" role="alert">{loginError}</p>
          )}
          <label className="login-field">
            <span>Invitation code</span>
            <input
              value={invitationCode}
              onChange={(event) => setInvitationCode(event.target.value.toUpperCase())}
              placeholder="ADP-XXXX-XXXX-XXXX-XXXX-XXXX"
              autoComplete="one-time-code"
              spellCheck="false"
            />
          </label>
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={() => console.error('Google login failed')}
            width="320"
            shape="rectangular"
          />
          <p className="login-terms">Nothing changes in Meta without your approval.</p>
        </div>
      </section>
    </div>
  );
}

export default LoginPage;
